export default {
	details: 'details',
	modal: {
		currentOwner: 'Current',
		footer: 'The above durations may include time the vehicle spent at a registered motor trader whilst awaiting sale.',
		subtitle: '{count} previous owner{plural}',
		table: { key: 'thead', label: 'Owner', value: 'Length of ownership' },
		title: 'Previous owners',
	},
};
